'use client';

import { PropsWithChildren } from 'react';

import { NextFonts } from './NextFonts';
import SharedProviders from './shared';

import type { ThemeName } from '@m/components-ui/themes/registry';

type NextProvidersProps = PropsWithChildren<{
  defaultTheme?: 'light' | 'dark';
  onThemeChange?: (theme: ThemeName) => void;
  themeName?: ThemeName;
}>;

export default function NextProviders({
  children,
  defaultTheme,
  onThemeChange,
  themeName,
}: NextProvidersProps) {
  return (
    <SharedProviders
      defaultTheme={defaultTheme}
      themeName={themeName}
      onThemeChange={onThemeChange}
    >
      <NextFonts />
      {children}
    </SharedProviders>
  );
}
